import { FC } from "react";
import { toast } from "react-toastify";
import { Formik, FormikValues } from "formik";
import { useNavigate } from "react-router-dom";

import ForgetPasswordForm from "./ForgetPasswordForm";

import * as authService from "../../../../services/auth";

import { useAppDispatch } from "../../../../redux/store";
import { setLoadingAction } from "../../../../redux/utils/actions";
import { forgetPassSchema, loginInitialData } from "../utils";
import RoutingList from "../../../../utils/RoutingList";

const ForgetPassword: FC = () => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const submitHandler = async (values: FormikValues) => {
    const { email } = values;
    try {
      dispatch(setLoadingAction(true));
      const res = await authService.forgetPass({ email });
      dispatch(setLoadingAction(false));
      toast.success(res.data.msg);
      navigate(RoutingList.login.index);
    } catch (err: any) {
      dispatch(setLoadingAction(false));
    }
  };

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={forgetPassSchema}
      initialValues={loginInitialData}
      onSubmit={(values) => {
        submitHandler(values);
      }}
    >
      <ForgetPasswordForm />
    </Formik>
  );
};

export default ForgetPassword;
